import React, { Fragment } from "react";

import RateVariationT1 from "../common/RateVariationT1";

import {
  FlexWrapperT2,
  FlexWrapperT3,
} from "Components/Common/Wrapper/FlexWrapper";
import { Spacer } from "Components/Common/Spacer/index";
import {
  TypographyT26,
  TypographyT27,
  TypographyT28,
} from "Components/Common/Typography/index";

const HeaderInfoDetails = (props) => {
  const { rate, variationRate } = props;
  return (
    <Fragment>
      <FlexWrapperT2>
        <FlexWrapperT3>
          <TypographyT26 variant="h5">TOTAL RAIL FREIGHT</TypographyT26>
          {/* <TypographyT27 variant="h6">(per MT)</TypographyT27> */}
        </FlexWrapperT3>
        <FlexWrapperT3>
          {/* <RateVariationT1 rate={variationRate} /> */}
          <Spacer spacing={"0px 3px"} />
          <TypographyT28 variant="h6">{rate}</TypographyT28>
        </FlexWrapperT3>
      </FlexWrapperT2>
    </Fragment>
  );
};

export default HeaderInfoDetails;
